import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";
import { residenceRelated } from "../services/soar";
import { name } from "@azure/msal-browser/dist/packageMetadata";

function FPTiers({ data, refreshData }) {
  const [showModal, setShowModal] = useState(false);
  const [tierData, setTierData] = useState({
    tier: "",
    effective: "",
  });

  const applicationId =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
      : "58990f83-8566-4ba8-b4b5-584a64e4cba1";

  const handleAddTier = async () => {
    if (
      data.related?.filter(
        (item) => item.type === "FP Tier" && !item.expiration
      )?.length > 0
    ) {
      const activeTiers = data.related.filter(
        (item) => item.type === "FP Tier" && !item.expiration
      );
      activeTiers.forEach(async (item) => {
        const body = {
          command: "expire",
          application: applicationId,
          id: item.id,
          expiration: tierData.effective,
        };
        await residenceRelated(body);
      });
    }
    const body = {
      command: "insert",
      application: applicationId,
      residence: data.id,
      type: "FP Tier",
      value: tierData.tier,
      effective: tierData.effective,
    };
    const response = await residenceRelated(body);
    if (response.code === "success") {
      toast.success("Tier added successfully!");
      refreshData();
      setTierData({ tier: "", effective: "" });
      setShowModal(false);
    } else {
      toast.error("Error adding tier: " + response.message);
    }
  };

  const handleDeleteTier = async (id) => {
    const response = await residenceRelated({
      command: "deactivate",
      application: applicationId,
      id: id,
    });
    if (response.code === "success") {
      toast.success("Tier deleted successfully!");
      refreshData();
    } else {
      toast.error("Error deleting tier: " + response.message);
    }
  };

  return (
    <div className="mb-4">
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Add Foster Parent Tier</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FloatingInput
            type="select"
            name="tier"
            label="Tier"
            options={[
              { _id: "1", name: "1" },
              { _id: "2", name: "2" },
              { _id: "3", name: "3" },
            ]}
            value={tierData.tier}
            onChange={(e) => setTierData({ ...tierData, tier: e.target.value })}
            placeholder="Enter Tier"
          />
          <FloatingInput
            type="date"
            name="effective"
            label="Effective Date"
            value={tierData.effective}
            onChange={(e) =>
              setTierData({ ...tierData, effective: e.target.value })
            }
            placeholder="Enter Effective Date"
          />
        </Modal.Body>
        <Modal.Footer>
          <div
            className="btn btn-primary"
            onClick={() => {
              if (tierData.tier && tierData.effective) {
                // Call the API to add the tier
                handleAddTier();
                refreshData();
                setShowModal(false);
              } else {
                toast.error("Please fill in all fields.");
              }
            }}
          >
            Save
          </div>
          <div
            className="btn btn-secondary"
            onClick={() => {
              setTierData({ tier: "", effective: "" });
              setShowModal(false);
            }}
          >
            Close
          </div>
        </Modal.Footer>
      </Modal>

      <div className="row">
        <div className="col-10">
          <div className="h3 mb-4">Foster Parent Tier</div>
        </div>
        <div className="col-2">
          <div
            className="btn btn-primary float-end"
            role="button"
            onClick={() => setShowModal(true)}
          >
            Add Tier
          </div>
        </div>
      </div>
      {data?.related?.filter(
        (item) => item.active === true && item.type === "FP Tier"
      )?.length > 0 ? (
        <>
          {" "}
          <div className="row fw-bold mb-2">
            <div className="col">Tier</div>
            <div className="col">Effective</div>
            <div className="col">Expiration</div>
            <div className="col"></div>
          </div>
          {data.related
            .filter((item) => item.active === true && item.type === "FP Tier")
            .map((item) => (
              <div
                className="row card-safy rounded border border-dark bg-light p-1 mb-2"
                key={item.id}
              >
                <div className="col">{item.value}</div>
                <div className="col">{item.effective}</div>
                <div className="col">{item.expiration}</div>
                <div className="col">
                  <i
                    className="rounded border border-dark fas fa-trash text-danger bg-white float-end p-2"
                    role="button"
                    onClick={() => handleDeleteTier(item.id)}
                  ></i>
                </div>
              </div>
            ))}
        </>
      ) : (
        "No FP Tier Found"
      )}
    </div>
  );
}

export default FPTiers;
